import BuyerDashboard from '@features/buyer/dashboard';
import R8trDashboard from '@features/r8tr/dashboard';
import Box from '@mui/material/Box';

const HomeDashboard = (): JSX.Element => {
  const userRole = localStorage.getItem('userRole');

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 65px)',
        width: '100%',
        bgcolor: 'background.default',
      }}
    >
      {userRole === 'buyer' ? <BuyerDashboard /> : <R8trDashboard />}
    </Box>
  );
};

export default HomeDashboard;
